import React, { useMemo } from 'react';
import { TableCellProps } from '../../../types/search';

const PortalCellDate: React.FC<TableCellProps> = ({ row, listingType }) => {
  const date = useMemo(() => new Date(row.jobDate), [row.jobDate]);

  const dayName = useMemo(
    () =>
      date.toLocaleDateString('en-GB', {
        weekday: 'short',
        timeZone: 'UTC',
      }),
    [date]
  );

  const monthAndDay = useMemo(
    () =>
      date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        timeZone: 'UTC',
      }),
    [date]
  );

  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--date-due`}>
      <p>{dayName}</p>
      <p>{monthAndDay}</p>
    </div>
  );
};

export default PortalCellDate;
